module.exports = __webpack_public_path__ + "static/media/UN-05.25ff16e5.jpg";